import "../books.css";

const two = (
  <div>
    <h2 id="a-place-to-stay">A Place to Stay</h2>
    <p>
      Myles woke at dawn to a rumbling stomach and a slightly stiff neck. He had
      rolled off of the tarp in the night and slept flat on the wooden planks of
      the floor. He rose and headed out the door.
    </p>
    <p>
      It was his first day of freedom and it was time to find answers to some of
      his questions and hopefully some food. Knowing you needed money to buy
      food or books Myles decided to try to get a job. It might put him in
      danger if people were looking for him, but stealing food and books would
      hardly be inconspicuous.
    </p>
    <p>
      The Alley outside was even more deserted in the early hours of the morning
      and he made his way back towards the busier streets, where he thought his
      quest for a job would be more successful. It was early enough that the
      Alley was lit more by street lamps than by the sun, and most of the shops
      were closed.
    </p>
    <p>
      When he decided he was close enough to the busy portion of the Alley to
      begin his search he knocked on the first door to his right, a restaurant
      of sorts titled &quot;Hungry Hippogriffs.&quot;
    </p>
    <p>&quot;We&#39;re not open yet,&quot; a burly voice yelled from inside.</p>
    <p>
      &quot;I&#39;m looking for a job,&quot; Myles replied, thinking this
      wasn&#39;t going so very well.
    </p>
    <p>
      The door abruptly opened before him and the man looked dismissively down
      at him before saying &quot;Bugger off kid&quot; and slamming the door
      shut. Myles shook off his failure and tried again, and again, and again,
      and again. Some of the shop owners and workers had been kinder, and some
      even ruder than the first but none of them had even considered him for
      work.
    </p>
    <p>
      After his fifteen attempt he was beginning to doubt his chances but
      decided he would try one more shop. The shop in his quest was titled
      &quot;Beth&#39;s Potions &amp; Healing&quot; with a description underneath
      the main sign stating &quot;Cures for Ailments, Injures, &amp; Injury
      Alike.&quot;
    </p>
    <p>
      Unlike most of the other shops in the Alley at this hour it was open and
      accepting customers, though Myles didn&#39;t see any in the shop at the
      moment. A light but very clear sounding bell rang off as he opened the
      door and he entered the shop. The store was much smaller than the first
      restaurant she had tried, no more than twelve feet wide, but it was packed
      from floor to ceiling to make up for it. Potted plants hung overhead,
      giving off a pleasant aroma yet simple aroma that made Myles instantly
      like the shop. The shelves were packed with a variety of goods, auto
      tightening bandages, skin care treatments, and a large number of potions
      with different names.
    </p>
    <p>
      &quot;Come on back.&quot; a woman&#39;s voice called out. Myles walked
      around the shelves to see a wide desk and a simply dressed and comely
      young woman sitting behind it.
    </p>
    <p>&quot;What can I do for you dear?&quot; she asked.</p>
    <p>&quot;I&#39;m looking for work.&quot; Myles replied.</p>
    <p>
      &quot;Oh, really?&quot; the woman said with amusement. &quot;What are your
      skills young man?&quot;
    </p>
    <p>
      &quot;I can read and write, do algebra and some arithmetic calculations,
      clean, and…&quot; Myles didn&#39;t really know what he could that would be
      of use to the woman, &quot;Follow instructions,&quot; he finished lamely.
    </p>
    <p>
      &quot;And how much do you charge for a day of work?&quot; the woman asked,
      clearly not taking him entirely seriously but still far more receptive
      than the other shop owners.
    </p>
    <p>
      &quot;Uhm…&quot; Myles had seen a sign yesterday selling supreme deluxe
      sundaes for three Sickles. He had no intention of buying sundaes but he
      figured he would need to make more than a sundae cost if he was going to
      feed himself and buy books. &quot;Ten Sickles.&quot;
    </p>
    <p>
      &quot;Well that&#39;s a steal.&quot; the woman said with a kind smile.
      &quot;I could use an assistant.&quot; She stood up and extended her hand
      to Myles. &quot;Ms. Lenore.&quot;
    </p>
    <p>
      &quot;Myles.&quot; he replied as he shook her hand. He had considered
      using a fake name, maybe even Muren, but something about the woman
      convinced him to tell the truth.
    </p>
    <p>
      Mrs. Lenore owned and ran Beth&#39;s Cures by herself. Beth&#39;s, named
      for Mrs. Lenore&#39;s grandmother, was a walk-in clinic that dealt with
      all kinds of illness and injury. It rarely got patients with serious
      afflictions except when they were too poor to afford St. Mungo&#39;s and
      specialized in the &quot;more discretionary medicines and treatments&quot;
      as well as performing general treatment for Lower Alley dwellers who were
      too poor to go to St. Mungo&#39;s. Mrs. Lenore also did house calls,
      implying that that was where much of the store&#39;s income came from.
    </p>
    <p>
      She was hiring Myles to look after the shop when she went on house calls
      and to help manage inventory, mail orders, and other tasks that didn&#39;t
      require expertise or magical ability. Myles quickly picked the basics of
      running the shop and customers began as morning came into a respectable
      hour customers began coming in.
    </p>
    <p>
      Mrs. Lenore dealt with her customers with kindness and a capable
      professionalism that Myles admired. When she went on house calls Myles
      minded the desk, asking people who came for immediate assistance to wait
      and noting down special orders (Mrs. Lenore made custom healing potions
      for those with allergies or other complications that made the standard for
      their ailment unusable).
    </p>
    <p>
      Myles found watching Mrs. Lenore make potions or cast healing spells
      fascinating and while he never asked about what she was doing because he
      didn&#39;t want to bother her, she noticed the interest he showed in her
      work and began to explain what she did and why. He didn&#39;t understand
      much of it but was certain he could learn to.
    </p>
    <p>
      He was sent to go buy ingredients at the local apothecary at midday. The
      streets that had been deserted in the early morning were once again
      bustling with traffic, though Beth&#39;s was a distance away from the
      busiest area of Diagon Alley. Myles made his way to Mr Mulpepper&#39;s
      Apothecary and filled a bag with dittany, knotgrass, mandrake leaf, and a
      variety of other ingredients before presenting his bag and Mrs.
      Lenore&#39;s check to the clerk. She gave him a speculative look, but
      accepted the check and waved him on.
    </p>
    <p>
      Beth&#39;s held the aroma of hot food when he returned and his grumbling
      stomach reminded him how hungry he was. He pushed the sensation down,
      reminding himself he would be able to eat when Beth&#39;s closed and
      walked to the back of the shop.
    </p>
    <p>
      &quot;Myles!&quot; Mrs. Lenore called. &quot;A friend of mine brought us
      lunch. Set down the ingredients and eat, you can log them and put them
      away later.&quot;
    </p>
    <p>
      Myles eagerly set the bag down and began to dig into the pile of
      sandwiches on the table. They were delicious: mayonnaise, mustard, cheese,
      and meat melted delightfully in his mouth. He had never gone hungry in the
      Orphanage, but neither had the food there ever been particularly tasty. He
      was too hungry to care about appearances as he practically shoved food
      into his mouth, but he did notice the concerned and thoughtful look Mrs.
      Lenore was giving him.
    </p>
    <p>
      He worried that she would pry and force him to lie, but she kept her
      distance. Myles didn&#39;t miss the careful way she treated him as if he
      was a startled rabbit she was trying not to scare away.
    </p>
    <p>
      &quot;Where are you sleeping Myles?&quot; Mrs. Lenore asked, having
      decided she would risk the question.
    </p>
    <p>
      &quot;At home.&quot; Myles replied, not looking Mrs. Lenore in eyes. He
      had never lied to Livian and had hardly ever talked to the other kids
      except to exchange insults and didn&#39;t feel comfortable doing so now.
    </p>
    <p>
      &quot;Of course.&quot; Mrs. Lenore answered in a perfectly neutral tone.
      In what was surely a coincidence she walked into the storage room and
      pulled out a pillow and a blanket which she placed in the corner of the
      desk room.
    </p>
    <p>
      The shop closed at four and Mrs. Lenore counted out his wages for the day
      - 10 sickles and asked, &quot;Would you like to go get ice cream with me
      Myles?&quot;
    </p>
    <p>
      &quot;Yes, very much Mrs. Lenore.&quot; Myles responded a bit excitedly.
      He had never tried ice cream before and the advertisements had piqued his
      interest.
    </p>
    <p>
      &quot;Let&#39;s head out then.&quot; Mrs. Lenore said with a smile. She
      beckoned him out the front door and locked it behind her. They didn&#39;t
      talk as they walked to Florean&#39;s Icecream Parlor, both of them
      comfortable with silence and neither sure what to say. The line there was
      long but it moved, benefits of having a wizard serving the ice cream.
    </p>
    <p>
      Myles was overwhelmed by the menu posted over the counter. He hadn&#39;t
      imagined there could be so many different flavors and so many ways to
      arrange ice cream with other treats.
    </p>
    <p>&quot;What are you going to order?&quot; Mrs. Lenore asked.</p>
    <p>
      &quot;I have no idea,&quot; Myles said honestly. &quot;What do you
      recommend?&quot;
    </p>
    <p>
      &quot;I heard the banana split sundae on the poster outside is amazing.
      Would you like split one?&quot;
    </p>
    <p>
      &quot;That would be perfect.&quot; Myles grinned wide and his facial
      muscles didn&#39;t relax throughout their wait in line.
    </p>
    <p>
      &quot;Jay! It&#39;s been too long. That tincture of yours worked wonders,
      even St. Mungo&#39;s couldn&#39;t relieve the pain like that.&quot; The
      clerk and shop owner, judging by his name tag (OWNER: Alfred Florean) said
      in friendly tones to Mrs. Lenore. &quot;Is he family?&quot; He gestured to
      Myles.
    </p>
    <p>
      &quot;My assistant, and the longer you stay away from me means the longer
      you&#39;re healthy.&quot;
    </p>
    <p>
      &quot;Or maybe you just aren&#39;t getting enough ice cream!&quot; Mr.
      Florean quipped, prompting a small laugh from Mrs. Lenore which Mr.
      Florean seemed very pleased about. &quot;So what can I serve the two of
      you? It&#39;s on the house.&quot;
    </p>
    <p>&quot;Oh, no Alf. You know I couldn&#39;t.&quot;</p>
    <p>
      &quot;Nonsense.&quot; Mr. Florean said adamantly. &quot;What will you
      have?&quot;
    </p>
    <p>
      Mrs. Lenore reluctantly acquiesced, ordering the banana split and saying
      thank you too many times. Mr. Florean set the confection in order with a
      flourish of his wand, and Myles watched interestedly as different
      varieties of ice cream made their way to the wide bowl along with a banana
      that unpeeled itself and a drizzle of fudge.
    </p>
    <p>
      They took a seat inside and began to dig in. Myles had expected to enjoy
      the ice cream, but he hadn&#39;t imagined it would be so good. There were
      a variety of flavors stuffed into the treat, each of them delicious as the
      last: chocolate, vanilla, strawberry, buttermilk, roasted blueberry swirl,
      and others that he couldn&#39;t identify because he stopped asking Mrs.
      Lenore about each flavor and just enjoyed them.
    </p>
    <p>
      While Myles dug in, Mrs. Lenore ate in a conserved and relaxed fashion,
      watching her new assistant with the same careful gaze she reserved for her
      more troublesome patients. Even with Myles&#39;s enthusiastic attempts,
      they didn&#39;t come near finishing the bowl - it was simply too much and
      while Mrs. Lenore certainly enjoyed the ice cream, she wasn&#39;t stuffing
      her face by any means.
    </p>
    <p>
      Myles, his attention focused completely on the flavors in his mouth,
      failed to notice people gathering in and around the parlor and realized
      their attention was focused on a family currently sitting in the corner of
      the shop.
    </p>
    <p>
      They did not seem to be enjoying the attention. The father, a man Myles
      found formidable though he couldn&#39;t say why, sat tense in his seat and
      held his ice cream cone with a grip that Myles was surprised didn&#39;t
      break it. The others didn&#39;t seem quite as bothered: the mother looked
      slightly uncomfortable but otherwise unbothered and the youngest and
      oldest children didn&#39;t seem to mind at all while the middle child
      looked rather embarrassed.
    </p>
    <p>
      &quot;Who are they?&quot; Myles asked, noticing that Mrs. Lenore
      wasn&#39;t bothering to stare at the family.
    </p>
    <p>
      &quot;The Potters.&quot; Mrs. Lenore answered, and looked surprised at
      Myles&#39;s blank face. &quot;You know, Harry Potter.&quot; Myles still
      had no clue what she was talking about and she continued confused.
      &quot;He defeated You-Know-Who in the war.&quot;
    </p>
    <p>
      &quot;You-Know-Who?&quot; Myles thought that was a terrible title for a
      wizard, was he expected to know who?
    </p>
    <p>
      Ms. Lenore was confused with Myles&#39;s lack of knowledge but
      uncomfortable with the subject and decided to steer their conversation in
      a different direction. &quot;How old are you Myles?&quot;
    </p>
    <p>
      &quot;Eleven.&quot; The general consensus at the Orphanage was that you
      graduated at eleven, and Myles had been due to graduate on the
      Caretaker&#39;s next visit.
    </p>
    <p>
      &quot;So you&#39;ll be going to Hogwarts in a few weeks.&quot; Mrs. Lenore
      stated. &quot;Come on, I&#39;ll introduce you.&quot; Myles was beginning
      to worry about the Hogwarts assumption, he would have to deal with it
      somehow.
    </p>
    <p>
      &quot;Hello Harry, Ginny. Here for Hogwarts supplies?&quot; Mrs. Lenore
      greeted the two parents as she lead Myles to the table
    </p>
    <p>
      &quot;Oh, hello Jay,&quot; Mr. Potter said, relaxing when he realized it
      was not the press or some fan who wanted an autograph. &quot;It&#39;s been
      years. I hear you are running a clinic now?&quot;
    </p>
    <p>
      &quot;Yes, just a few minutes from here.&quot; Mrs. Lenore replied.
      &quot;I&#39;m doing alright.&quot;
    </p>
    <p>
      &quot;Is this your son?&quot; Mrs. Potter asked, smiling kindly at Myles,
      who felt uncomfortable under all the attention (everyone in the parlor was
      looking at the Potters and him by association).
    </p>
    <p>
      &quot;My assistant,&quot; Mrs. Lenore ignored the odd looks the Potters
      gave her at having an eleven year old assistant. &quot;He&#39;ll be
      heading to Hogwarts soon so I thought I&#39;d introduce him to some other
      students, I think Albus is going into his first year as well?&quot;
    </p>
    <p>
      &quot;Yes he is,&quot; Mrs. Potter said smiling. &quot;James here is going
      into his third year and Lily will be attending in a couple of years. Say
      hello boys, Lilly.&quot;
    </p>
    <p>
      The adults talked and he introduced himself awkwardly to the Potter
      children. James didn&#39;t seem interested in him, Albus stammered a
      little, and Lily enthusiastically asked him what he did as an assistant
      but when he replied that he only helped with shopping she lost interest as
      well.
    </p>
    <p>
      Myles was glad when Mrs. Lenore said her farewells to the Potters and they
      left the Mr. Florean&#39;s, the conversation between him and the Potter
      children had felt forced, though it seemed Mrs. Lenore had talked amicably
      with the parents.
    </p>
    <p>
      &quot;How do you know them?&quot; Myles asked, curious how Mrs. Lenore met
      people who were evidently famous.
    </p>
    <p>
      &quot;Harry headed a school club that I was in at Hogwarts for a year, the
      DA. I hear it&#39;s still an active club, maybe you&#39;ll want to join
      this year.&quot; she replied.
    </p>
    <p>
      &quot;I think Mr. Florean likes you.&quot; Myles said, partially to steer
      the conversation away from Hogwarts and partially because he thought it
      was obvious. He was surprised to see Mrs. Lenore flush and stammer, the
      least composed he&#39;d seen her yet.
    </p>
    <p>
      &quot;Surely not.&quot; she finally responded with an air of finality and
      they walked the rest of the way back to Beth&#39;s in silence.
    </p>
    <p>
      It didn&#39;t seem that Mrs. Lenore had any reason to return to the shop
      except to grab an item seemingly at random from the back and then ask
      Myles to lock up when he left. This conveniently left Myles alone in the
      shop with a blanket, pillow, and leftover sandwiches.
    </p>
    <p>
      Myles locked the door and wondered about Mrs. Lenore. Perhaps he should
      have been worried that she clearly knew he was a runaway, but there was
      something implicitly trustworthy about the healer. He considered going to
      sleep right then, but was drawn to one of the few books that Mrs. Lenore
      had for sale.
    </p>
    <p>
      He looked through all their titles and picked out the most beginner
      friendly one, &quot;An Introduction to the Art of Healing: Practical Guide
      and Basic Theory.&quot;
    </p>
    <p>Myles brought the thick book to the desk and began to read:</p>
    <p>
      <em>
        &quot;The healing arts, despite their general usefulness and life saving
        potential, are neglected by the general population. This is due to the
        control non-trivial healing charms require. Healing a simple cut (see
        page 3) requires little more than the incantation and its wand movement,
        but dealing with even cleanly broken bones without control and the
        proper intentions can lead to disastrous effect. This text primarily
        details trivial healing, with an introduction to low-level non-trivial
        spells once the necessary background has been established.&quot;
      </em>
    </p>
    <p>
      It had been almost a year since Myles had read something new, and he
      immersed himself with the new text. He practiced the incantations and
      detailed wand motions with his new wand, though he couldn&#39;t be sure he
      was doing them correctly.
    </p>
    <p>
      Drooping eyes and the return of his grumbling stomach eventually drew him
      away from the text. He noted his place in the book with pleasure, well
      over a quarter of the way through, and closed it. It was later than he
      realized, seeing the hour hand a quarter past nine on the clock.
    </p>
    <p>
      Myles finished the leftover sandwiches (they were just as delicious as
      before) and collapsed on the floor. He took out his old wand and the piece
      of parchment Cecillia had given him, reading it for the first time.{" "}
    </p>
    <p>
      <strong>Seren Manor, 18th Knightdale Valley</strong>
    </p>
    <p>
      He thought about the unusual girl that had given him the parchment and
      wondered how he was going to find Livian, running his hand down the
      makeshift wand that housed a strand of her hair. After a moment Myles put
      the items back in his pocket, then arranged the pillow and blanket into a
      comfortable position and fell asleep almost instantly, feeling safe and
      content for the first time in a long time.
    </p>
  </div>
);

export default two;
